<template>
  <div id="success" class="section">
    <h1>
      <span class="section-title">Success</span>
      <span class="section-description">{{ $t('success.title') }}</span>
    </h1>

    <div>
      <p v-if="this.$route.query.msg['subscribed-api']">{{ $t('success.api') }}</p>
    </div>

    <div class="margin-top-30px">
      <ButtonDashboard></ButtonDashboard>
    </div>
  </div>
</template>

<script>
import appConfig from "../app.config.json";
import { useHead } from "@unhead/vue";
import ButtonDashboard from "../components/ButtonDashboard.vue";

export default {
  name: 'Success',
  components: {
    ButtonDashboard,
  },
  created() {
    useHead({
      title: `${this.$t('success.title')} | ${appConfig[this.$i18n.locale].title}`,
      meta: [
        { name: 'description', content: appConfig[this.$i18n.locale].description.top },
        { name: 'robots', content: 'noindex,nofollow' }
      ]
    })

    if (this.$route.query.msg === 'subscribed-premium') {
      this.$store.commit('updateSubscription', { isPremium: true, isBusiness: false, isFree: false, isAPIUser: false })
    }
    if (this.$route.query.msg === 'subscribed-business') {
      this.$store.commit('updateSubscription', { isPremium: false, isBusiness: true, isFree: false, isAPIUser: false })
    }
    if (this.$route.query.msg === 'subscribed-api') {
      this.$store.commit('updateSubscription', { isPremium: false, isBusiness: false, isFree: false, isAPIUser: true })
    }
    if (this.$route.query.msg === 'unsubscribed') {
      this.logout()
    }
  }
}
</script>
